import React from 'react'
import useFilterProducts from '@common/hooks/use-filter-product'
import ShopLayout from '@layouts/shop-layout'

const Shop = () => {
  const useFilter = useFilterProducts()

  return (
    <ShopLayout textHeader={'Shop'} useFilter={{ ...useFilter, hides: [] }} />
  )
}

export default Shop
